// Gala icon set ("gala-add"), https://github.com/sisyphusion/gala-icons -- GPL licensed.
export const CirclePlusIcon = (props) => (
  <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 256 256" {...props}>
    <circle cx="128" cy="128" r="112.00011" strokeWidth={16} />
    <path d="M 79.999992,128 H 176.0001" strokeWidth={16} />
    <path d="m 128.00004,79.99995 v 96.0001" strokeWidth={16} />
  </svg>
);
